$(function () {
        let $button = $('#download-modal-btn')
        let $modal = $('.download-modal');

        if ($button.length > 0 && $modal.length > 0) {
            $modal = bootstrap.Modal.getOrCreateInstance($modal);

            $button.on('click', function (e) {
                $modal.show()
            })
/*
            $modal.addEventListener('hidden.bs.modal', function (event) {
                $modal.dispose();
            })*/
        }
    }
);
